import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Tooltip, Typography, Button, Divider } from "antd";
import { Link } from "react-router-dom";
import { linksRouter } from "../../../config/RouterLink";
import { Preguntas } from "./Preguntas";
import moment from "moment";
//imgs
import { ReactComponent as MesaTrabajo } from "../../../assets/img/home/mesa-trabajo.svg";
import { ReactComponent as ImgFecha } from "../../../assets/img/home/fecha.svg";
import { ReactComponent as ImgRegistro } from "../../../assets/img/home/registro.svg";

import { archivosRegistrarse } from "../../../utils/funciones";
//Icons
import { ExportOutlined } from "@ant-design/icons";

//CSS
import "./Home.css";
import { getValorParametro } from "../../../redux/aspirante/catalogoDucks";
// import { descargaPrivacidad } from "../../../redux/avisoprivacidad/descargaPrivacidad";
import { DATE_FORMAT_EXP, FECHA_LIM_REGISTRO } from "../../../utils";

/**Redux-Ducks */
import {
  obtenerSistemaINE,
  obtenerSistemaOPLE,
  MaterialesINE,
  MaterialesOPLE,
  getFechaPostulacion,
} from "../../../redux/consultavacantes/sistemasDucks";
import {
  asignarSistema,
  asignarConcurso,
  asignarConvocatoria,
} from "../../../redux/consultavacantes/consultaVacantesDucks";

const { Text } = Typography;

export const Home = () => {
  const {
    sistemaINE,
    sistemaOPLE,
    materialesINE,
    materialesOPLE,
    get_registro,
    get_FechaPostulacion,
  } = useSelector((state) => state.sistemas);

  const dispatch = useDispatch();

  const [fecha, setFecha] = useState("");

  useEffect(() => {
    dispatch(getValorParametro(FECHA_LIM_REGISTRO)).then(({ data }) => {
      setFecha(data.valorConfig);
    });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  useEffect(() => {
    dispatch(obtenerSistemaINE());
    dispatch(obtenerSistemaOPLE());
    dispatch(MaterialesINE());
    dispatch(MaterialesOPLE());
    dispatch(getFechaPostulacion());
  }, [dispatch]);

  const seleccionarConvocatoriaINE = (item) => {
    dispatch(obtenerSistemaINE(item));
    dispatch(asignarSistema(sistemaINE?.idSistema));
    dispatch(asignarConcurso(sistemaINE?.idConcurso));
    dispatch(asignarConvocatoria(sistemaINE?.idConvocatoria));
  };

  const seleccionarConvocatoriaOPLE = (item) => {
    dispatch(obtenerSistemaOPLE(item));
    dispatch(asignarSistema(sistemaOPLE?.idSistema));
    dispatch(asignarConcurso(sistemaOPLE?.idConcurso));
    dispatch(asignarConvocatoria(sistemaOPLE?.idConvocatoria));
  };

  // const downloadIntegral = () => {
  //   let ruta = JSON.stringify({
  //     tipoRuta: "integral",
  //   });
  //   dispatch(descargaPrivacidad(ruta));
  // };

  //const downloadSimplificado =() =>{
  //let ruta = JSON.stringify({
  //tipoRuta: "simplificado"
  //});
  //dispatch(descargaPrivacidad(ruta));
  //}

  // const validaFecha = () => {
  //   console.log("get_FechaPostulacion", get_FechaPostulacion)
  //   if (get_FechaPostulacion != null) {
  //     const hoy = moment().format("DD/MM/YY");

  //     console.log("hoy", hoy)

  //     const dateIni = get_FechaPostulacion.fechaInicio;
  //     const dateEnd = get_FechaPostulacion.fechaFin;

  //     console.log("frechas", dateIni, " -", dateEnd)

  //     if (hoy >= dateIni) {
  //       console.log("primer if")
  //       if (hoy <= dateEnd) {
  //         console.log("segundo if")
  //         return !true
  //       } else {
  //         return !false
  //       }
  //     } else {
  //       return !false
  //     }
  //   }
  // };

  const validaFecha = () => {
    if (get_FechaPostulacion !== null && get_FechaPostulacion !== undefined) {
      const { fechaInicio, fechaFin } = get_FechaPostulacion;
      const hoy = new Date(moment().format(DATE_FORMAT_EXP));
      const startDate = new Date(moment(fechaInicio).format(DATE_FORMAT_EXP));
      const endDate = new Date(moment(fechaFin).format(DATE_FORMAT_EXP));
      //Si la fecha actual es menor a la fecha inicio se bloquea el botón
      if (hoy < startDate) return true;
      //Si la fecha actual es igual o mayor a la fecha inicio y no existe fecha fin se habilita el botón
      if (hoy >= startDate && isNaN(endDate.getTime())) {
        return false;
      }
      //Si la fecha actual se encuentra en el rango de las fechas inicio y fin se habilita el botón
      //Si ya pasaron las fechas y el estatus se encuentra en 1, solo se bloquea el botón
      return hoy >= startDate && hoy <= endDate ? false : true;
    }
  };

  return (
    <>
      <div className="layout-content-public">
        <Row style={{ marginBottom: "10px" }}>
          <Col span={24}>
            <div>
              <Text style={{ fontSize: 30, fontWeight: 600 }}>
                Información General
              </Text>
            </div>
          </Col>
        </Row>
        <Row gutter={[24, 16]} className="rellenaHeight">
          {/* Primera tarjeta */}
          <Col xxl={14} xl={14} lg={24} md={24} sm={24} xs={24}>
            <div className="card-menu-home">
              <Row gutter={24}>
                <Col xxl={16} xl={16} lg={16} md={16} sm={16} xs={24}>
                  <div style={{ fontSize: 28, fontWeight: 300 }}>
                    Convocatorias
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 600, marginTop: 10 }}>
                    Antes de registrarte y postularte...
                  </div>
                  <p
                    style={{
                      fontSize: 14,
                      fontWeight: 400,
                      color: "#333333",
                      marginTop: 10,
                    }}
                  >
                    Consulta las plazas vacantes de las Convocatorias de ingreso
                    para ocupar cargos y puestos del Servicio Profesional
                    Electoral Nacional <b>(SPEN)</b>.
                  </p>
                  <div style={{ marginTop: "8%" }}>
                    {/* <p style={{ fontSize: 18, fontWeight: 600 }}>
                    Convocatorias Activas
                  </p> */}
                    {sistemaINE !== undefined && (
                      <Button type="primary" className="btn-convocatoria">
                        <Link
                          to={linksRouter.cvacantes}
                          onClick={seleccionarConvocatoriaINE}
                        >
                          {sistemaINE?.nombreConvocatoria}
                        </Link>
                      </Button>
                    )}
                  </div>

                  <div style={{ marginTop: "4%" }}>
                    {sistemaOPLE !== undefined && (
                      <Button
                        type="primary"
                        style={{ marginTop: 12 }}
                        className="btn-convocatoria"
                      >
                        <Link
                          to={linksRouter.cvacantes}
                          onClick={seleccionarConvocatoriaOPLE}
                        >
                          {sistemaOPLE?.nombreConvocatoria}
                          {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Ver detalle */}
                        </Link>
                      </Button>
                    )}
                  </div>
                </Col>
                <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                  <div style={{ marginTop: 25 }}>
                    <center>
                      <MesaTrabajo />
                    </center>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          {/* Segunfa tarjeta */}
          <Col xxl={5} xl={5} lg={12} md={12} sm={12} xs={24}>
            <div className="card-menu-home">
              <Row gutter={24}>
                <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={24}>
                  <ImgFecha />
                </Col>
                <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={24}>
                  <div className="texto-home">Fecha límite de registro</div>
                  {/* parametrizar */}
                  {/*  <div className="fecha-registro">{fecha && fecha}</div> */}
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <div className="fecha-registro">{fecha && fecha}</div>
                </Col>
              </Row>
              <div style={{ marginTop: 10 }}>
                <p className="aviso-privacidad">
                  La seguridad de tus datos es importante para nosotros.
                </p>
                {materialesINE?.activoConfiguracion === 1 && (
                  <Link to={linksRouter.avisoPrivacidadINE} className="link">
                    Aviso de privacidad INE
                  </Link>
                )}
                <br />
                {materialesOPLE?.activoConfiguracion === 1 && (
                  <Link to={linksRouter.avisoPrivacidadOPLE} className="link">
                    Aviso de privacidad OPLE
                  </Link>
                )}
              </div>
            </div>
          </Col>
          <Col xxl={5} xl={5} lg={12} md={12} sm={12} xs={24}>
            <div className="card-menu-home">
              <div
                style={{
                  fontWeight: 300,
                  fontSize: "18pt",
                  lineHeight: "22pt",
                  textAlign: "center",
                }}
              >
                Te brindamos mayor ayuda en tu proceso
              </div>
              <Divider />
              <div style={{ marginTop: 20 }}>
                <div
                  style={{
                    fontWeight: 300,
                    fontSize: "14pt",
                    lineHeight: "22pt",
                    textAlign: "center",
                  }}
                >
                  Conoce la normativa, los documentos y materiales de apoyo
                </div>
              </div>
              {materialesINE !== null &&
              materialesINE !== undefined &&
              materialesINE.activoConfiguracion === 1 ? (
                <div style={{ marginTop: 25 }}>
                  <Button
                    type="default"
                    className="btn-material_apoyo"
                    block
                    href={
                      materialesINE !== null && materialesINE.valorConfiguracion
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Concurso Público del sistema INE <ExportOutlined />
                  </Button>
                </div>
              ) : (
                <div style={{ marginTop: 25 }}></div>
              )}

              {materialesOPLE !== null &&
              materialesOPLE !== undefined &&
              materialesOPLE.activoConfiguracion === 1 ? (
                <div style={{ marginTop: 25 }}>
                  <Button
                    type="default"
                    className="btn-material_apoyo"
                    block
                    href={
                      materialesOPLE !== null &&
                      materialesOPLE.valorConfiguracion
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Concurso Público del sistema OPLE <ExportOutlined />
                  </Button>
                </div>
              ) : (
                <div style={{ marginTop: 25 }}></div>
              )}
            </div>
          </Col>
        </Row>
        {/* // ---------------------- Segunda fila--------------------------------- */}
        <Row gutter={[24, 24]} className="sectionMenu rellenaHeight altoSecond" >
          <Col xxl={14} xl={14} lg={24} md={24} sm={24} xs={24} className="containerAltoSecond">
            <Preguntas />
          </Col>
          <Col xxl={10} xl={10} lg={24} md={24} sm={24} xs={24}>
            <div className="card-menu-home limite-registro">
              <Row gutter={24}>
                <Col xxl={15} xl={15} lg={15} md={15} sm={15} xs={24}>
                  <p
                    style={{
                      fontSize: "18pt",
                      fontWeight: 300,
                      lineHeight: "22pt",
                    }}
                  >
                    ¿Qué necesito para registrarme?
                  </p>
                  <div className="requisitos">
                    Ten a la mano la siguiente información.
                  </div>
                  <div style={{ marginTop: 20 }}>
                    {archivosRegistrarse.map((archivo) => (
                      <Row key={archivo.id}>
                        <Col xs={3} sm={2} md={2} lg={3} xl={2} xxl={2}>
                            <div className="numero-requisito">{archivo.id}</div>
                        </Col>
                        <Col xs={21} sm={22} ms={22} lg={21} xl={22} xxl={22}>
                            <div className="requisitos" style={{ marginLeft: 10 }}>
                            {archivo.texto}{" "}
                            {archivo.texto === "CURP" ? (
                                <Text>{archivo.ejemplo}</Text>
                            ) : (
                                archivo.ejemplo && (
                                <Tooltip
                                    title={
                                    archivo.url ? (
                                        <img
                                        src={archivo.url}
                                        alt="ejemplo"
                                        width={"500px"}
                                        height={"500px"}
                                        />
                                    ) : (
                                        archivo.ejemplo
                                    )
                                    }
                                    color={"#ffffff"}
                                    placement="rightTop"
                                    overlayStyle={{ maxWidth: 800 }}
                                >
                                    {archivo.ejemplo}
                                </Tooltip>
                                )
                            )}
                            </div>
                        </Col>
                      </Row>
                    ))}
                  </div>
                </Col>
                <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                  <div style={{ marginTop: 50 }}>
                    <ImgRegistro />
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        {get_registro !== null &&
        get_registro !== undefined &&
        get_registro.valorConfiguracion === "1" ? (
          <Row>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 8, offset: 8 }}
              lg={{ span: 4, offset: 10 }}
              hidden={validaFecha()}
              style={{ textAlign: "center" }}
            >
              <Link
                to={linksRouter.registro}
                type="link"
                className="registrate"
              >
                <Button
                  disabled={validaFecha()}
                  type="default"
                  className="btn-registrar"
                  block
                >
                  Registrarme
                </Button>
              </Link>
            </Col>
          </Row>
        ) : (
          <div style={{ marginTop: 25 }}></div>
        )}
      </div>
    </>
  );
};
